module.exports = __webpack_public_path__ + "images/Group-072fcb.png";